import {useMutation} from '@apollo/react-hooks';

import type {
    RemoveContactForLead as RemoveContactForLeadMutation,
    RemoveContactForLeadVariables as RemoveContactForLeadMutationVariables,
    LeadRemoveContactInput,
} from 'nutshell-graphql-types';

import REMOVE_CONTACT_FOR_LEAD from '../mutations/remove-contact-for-lead.graphql';

export function useRemoveContactForLead(): {
    removeContact: (input: LeadRemoveContactInput) => Promise<any>;
    isLoading: boolean;
} {
    const [leadRemoveContact, {loading}] = useMutation<
        RemoveContactForLeadMutation,
        RemoveContactForLeadMutationVariables
    >(REMOVE_CONTACT_FOR_LEAD);

    return {
        removeContact: (input: LeadRemoveContactInput) => {
            return leadRemoveContact({
                variables: {input},
            });
        },
        isLoading: loading,
    };
}
